export default __webpack_public_path__ + "static/93fd95fc-c11f-47be-bd25-5f5f54288ac5-767937265ca245ea47a740642b317b67.woff";